import React, { createContext, useContext, useState } from "react";
import Loader from "./Loader";
 
const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

const LoaderProvider = ({ children }) => {
  const [isFullScreenLoading, setIsFullScreenLoading] = useState(false);

  const showLoader = () => setIsFullScreenLoading(true);
  const hideLoader = () => setIsFullScreenLoading(false);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}
      <Loader isFullScreenLoading={isFullScreenLoading} />
    </LoaderContext.Provider>
  );  
};

export default LoaderProvider;
